import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import { ConstrainedText } from '~components/Text';
import Quote from '~components/Quote';
import Embed from '~components/Embed';

// Page Navigation
import PageNav from '~components/PageNav';
import FannyCard from '~components/PageCard/FannyCard';
import KidsForCureCard from '~components/PageCard/KidsForCureCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Charli-Mae Herndier, diagnostic à l’âge de 2 ans et ses parents — Julie et Kevin Herndier" desc="Description" />
      <Hero title="Charli-Mae Herndier, diagnostic à l’âge de 2 ans et ses parents — Julie et Kevin Herndier">
        <StaticImage
          style={heroImgStyles}
          src="../../images/charli-mae-feature.jpg"
          alt=""
          layout="fullWidth"
        />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        Charli-Mae et ses parents ont été les ambassadeurs vedettes de l’édition 2020 du Roulons pour vaincre le diabète Sun Life FRDJ.
        </ConstrainedText>
        <ConstrainedText>
        À l’âge de 2 ans, Charli-Mae a commencé à présenter les symptômes de ce qui allait devenir une maladie auto-immune dont elle souffrirait toute sa vie. Ses parents n’auraient jamais pu imaginer que leur petite fille serait diagnostiquée avec le DT1.
        </ConstrainedText>
        <ConstrainedText>
        Ils n’oublieront jamais le jour où ils l’ont emmenée d’urgence à l’hôpital, où elle a reçu sa première injection d’insuline. Depuis lors, la famille a effectivement réorganisé leur vie pour que son diabète et ses soins soient toujours une priorité. 
        </ConstrainedText>
        <ConstrainedText>
        Participer à ce projet a donné à Julie et Kevin l’occasion de recueillir des fonds et de faire savoir à d’autres personnes que FRDJ et la recherche qu’elle soutient peuvent apporter un changement énorme dans la vie de personnes comme Charli-Mae, dont ils espèrent qu’un jour, elle n’aura plus jamais à se faire piquer.
        </ConstrainedText>
        <ConstrainedText>
        Ils feraient n’importe quoi pour rendre à leur fille ces années sans injections d’insuline, sans piqûres, mais grâce aux efforts déployés pour trouver une guérison, ils ont bon espoir pour son avenir.
        </ConstrainedText>
        <Quote>
        Notre fille parle toujours d’un traitement comme s’il s’agissait d’une enveloppe magique que les chercheurs recherchent chaque jour. Nous voulons vraiment qu’elle reçoive bientôt cette « enveloppe ».
        </Quote>
        <Embed
          src="https://www.youtube.com/embed/kq7Yk6S8Vrg"
          title="Charli Mae vidéo"
        />
        <PageNav previous={<FannyCard />} next={<KidsForCureCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
